export const FILTER_NAME = 'movement'

export const SAVE_DRAFT = 'save-draft'
export const SAVE_COMPLETE = 'save-complete'
